import * as React from "react";

import useAuthentication from "./useAuthentication";
import { cancelRoleRequest } from "../services/users";

const useCancelRoleRequest = () => {
	const { getToken, handleLogout } = useAuthentication();
	const [loading, setLoading] = React.useState(false);

	const cancelRole = React.useCallback(
		async (appId?: string) => {
			try {
				if (appId) {
					setLoading(true);
					const token = await getToken();
					const authHeader = {
						headers: {
							authorization: `Bearer ${token}`,
						},
					};
					const { data } = await cancelRoleRequest(authHeader, appId);
					return data?.message;
				}
			} catch (error: any) {
				if (error) {
					if (error?.response?.status == 401) {
						handleLogout();
					}
					return error?.response?.data?.message as string;
				}
			} finally {
				setLoading(false);
			}
		},
		[getToken, handleLogout]
	);

	return { cancelRole, loading };
};

export default useCancelRoleRequest;
